import React from 'react';
import { Menu } from 'antd';
import ILogout from 'icons/ILogout';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from 'components/Auth/Auth';

interface LogoutButtonProps {
  onLogout?: () => void;
}

const LogoutButton = ({ onLogout }: LogoutButtonProps) => {
  const navigate = useNavigate();
  const context = useContext(AuthContext);

  const handleLogout = () => {
    context.setToken('');
    localStorage.clear();
    navigate('/login');
    localStorage.setItem('changepassword', '');
    if (onLogout) onLogout();
  };

  return (

      <ILogout onClick={handleLogout} id="logout" />

  );
};

export default LogoutButton;
